import { Divider, Stack } from '@mui/material';
import { EntitlementsList } from './EntitlementsList';
import { SearchEntitlement } from './Search';
import { SelectedFilters } from './SelectedFilters';
import { FilterTags } from 'Modules/CompassRights/UserEntitlementsPanel/FilterTags';
import { useIsDesktop } from 'Hooks';

interface IUserEntitlementsPanel {
  lastUpdateDate?: Date;
}

export const UserEntitlementsPanel = ({
  lastUpdateDate,
}: IUserEntitlementsPanel) => {
  const isDesktop = useIsDesktop();
  return (
    <Stack gap={'40px'}>
      <Stack gap={isDesktop ? '24px' : '40px'}>
        <SearchEntitlement />
        <FilterTags />
        <Divider
          orientation='horizontal'
          sx={{
            borderColor: isDesktop ? 'primary.shade_200' : 'primary.shade_100',
          }}
        />
      </Stack>
      <SelectedFilters />
      <EntitlementsList lastUpdateDate={lastUpdateDate} />
    </Stack>
  );
};
